import TheEventStartsIn15Min from "./TheEventStartsIn15Min";
export default TheEventStartsIn15Min;
